import React from 'react';
import { Router, Route } from 'react-router-dom';
import history from './history';
import Outreaches from './Outreach/Outreaches';
import OutreachAggregateReportHistory from './Reports/Outreach/OutreachAggregate/DownloadHistory';
import OutreachAggregateGenerateReport from './Reports/Outreach/OutreachAggregate/GenerateReport';
import OutreachAggregateReportView from './Reports/Outreach/OutreachAggregate/ReportView';
import InventoryDashboard from './Inventory/Dashboard';

import InventoryItems from './Inventory/Items';
import CreateInventoryItem from './Inventory/CreateItem/container/Item';
import EditInventoryItem from './Inventory/EditItem/container/Item';
import ViewInventoryItem from './Inventory/ViewItem/container/Item';
import AdjustInventoryItem from './Inventory/AdjustItem/container/Item';
import InventoryItemsAvailability from './Inventory/ItemsAvailability';
import InventoryItemsAuditLogs from './Inventory/AuditLogs';
import InventoryImportItems from './Inventory/ImportItems';
import InventoryImportItemsQuantity from './Inventory/ImportItemsQuantity';

import InventoryPackages from './Inventory/Packages';
import CreateInventoryPackage from './Inventory/CreateItem/container/Package';
import EditInventoryPackage from './Inventory/EditItem/container/Package';
import ViewInventoryPackage from './Inventory/ViewItem/container/Package';
import AdjustInventoryPackage from './Inventory/AdjustItem/container/Package';
import InventoryPackagesAvailability from './Inventory/PackagesAvailability';

import InventoryTags from './Inventory/Tags';
import InventoryLocations from './Inventory/Locations';
import InventoryCreateLocation from './Inventory/CreateLocation';
import InventoryEditLocation from './Inventory/EditLocation';
import InventoryViewLocation from './Inventory/ViewLocation';

import InventoryGuestSummaryReport from './Inventory/Reports/GuestSummary';
import InventoryDonorSummaryReport from './Inventory/Reports/DonorSummary';
import InventoryLowStockItems from './Inventory/Reports/LowStockItems';
import InventoryOnHand from './Inventory/Reports/OnHand';
import ItemsAndPackagesSkus from './Inventory/Reports/ItemsAndPackagesSkus';

import StorageDashboard from './Storage/Dashboard';
import StorageList from './Storage/List';

import PosOrder from './Pos/Order';

import ReservationsCreate from './Reservations/Create';
import ReservationsEdit from './Reservations/Edit';
import ReservationsView from './Reservations/View';
import ReservationsOrders from './Reservations/Orders';
import ReservationsTodays from './Reservations/Todays';
import ReservationsUpcoming from './Reservations/Upcoming';
import ReservationsPending from './Reservations/Pending';
import ReservationsDashboard from './Reservations/Dashboard';
import ReservationsUpcomingEvents from './Reservations/UpcomingEvents';
import ReservationsArchived from './Reservations/Archived';
import ReservationROItemCreate from './Reservations/ROItem/Create';
import ReservationROItemEdit from './Reservations/ROItem/Edit';
import ReservationROItemView from './Reservations/ROItem/View';
import ReservationROItemList from './Reservations/ROItem/List';
import ReservationROPicklistCreate from './Reservations/ROPicklist/Create';
import ReservationROPicklistEdit from './Reservations/ROPicklist/Edit';
import ReservationROPicklistView from './Reservations/ROPicklist/View';
import ReservationROPicklistList from './Reservations/ROPicklist/List';
import ReservationOrderedItemsReport from './Reservations/Reports/OrderedItems';

import GuestList from './Guest/List';
import GuestView from './Guest/View';
import GuestCreate from './Guest/Create';
import GuestMerge from './Guest/Merge';

import SettingsPortalDashboard from './Settings/Portal/Dashboard';
import SettingsPortalPantry from './Settings/Portal/Pantry';
import SettingsPortalUsers from './Settings/Portal/Users';
import SettingsPortalSmtpAccount from './Settings/Portal/SmtpAccount';

import SettingsPosDashboard from './Settings/POS/Dashboard';
import SettingsPosTrackingMethodLocations from './Settings/POS/TrackingMethodLocations';
import SettingsPosEditTrackingMethodLocations from './Settings/POS/EditTrackingMethodLocations';

import CreateNewVisit from './CreateNewVisit';
import VisitHistoryReport from './Reports/Guest/VisitHistoryReport';
import SignaturePad from './SignaturePad';
import GuestReservations from './GuestReservations';
import Login from './Login';

import {
  outreachBasePath,
  outreachAggregateReportPath,
  outreachAggregateReportHistoryPath,
  outreachAggregateReportViewPath,
  inventoryDashboardPath,
  inventoryItemsPath,
  inventoryPackagesPath,
  inventoryTagsPath,
  inventoryLocationsPath,
  inventoryCreateLocationPath,
  inventoryEditLocationPath,
  inventoryViewLocationPath,
  inventoryCreateItemPath,
  inventoryCreatePackagePath,
  inventoryEditItemPath,
  inventoryEditPackagePath,
  inventoryAdjustItemPath,
  inventoryAdjustPackagePath,
  inventoryViewItemPath,
  inventoryViewPackagePath,
  inventoryItemsAvailabilityPath,
  inventoryPackagesAvailabilityPath,
  inventoryItemsAuditLogsPath,
  inventoryItemsImportPath,
  storageDashboardPath,
  storageListPath,
  posViewOrderPath,
  inventoryGuestSummaryReportPath,
  inventoryDonorSummaryReportPath,
  inventoryLowStockItemsPath,
  inventoryOnHandPath,
  inventoryItemsAndPackagesSkusPath,
  reservationsBasePath,
  reservationsCreatePath,
  reservationsEditPath,
  reservationsViewPath,
  reservationsOrdersPath,
  reservationsTodaysPath,
  reservationsPendingPath,
  reservationsUpcomingPath,
  reservationsUpcomingEventsPath,
  reservationsArchivedPath,
  reservationsROItemCreatePath,
  reservationsROItemEditPath,
  reservationsROItemViewPath,
  reservationsROItemListPath,
  reservationsROPicklistCreatePath,
  reservationsROPicklistEditPath,
  reservationsROPicklistViewPath,
  reservationsROPicklistListPath,
  guestsBasePath,
  guestsViewPath,
  settingsPortalPath,
  settingsPortalPantryPath,
  settingsPortalUsersPath,
  settingsPosPath,
  settingsPosTrackingMethodLocationsPath,
  settingsPosTrackingMethodLocationsEditPath,
  signaturePadPath,
  inventoryItemsQauntityImportPath,
  reservationsOrderedItemsReportsPath,
  guestsCreatePath,
  createNewVisitPath,
  visitHistoryReportPath,
  guestReservationPath,
  guestsMergePath,
  guestsVisitTrackViewPath,
  settingsPortalSmtpAccountPath,
  loginPath
} from './Paths';
import VisitTrackView from './Guest/VisitTrackView';

const AppRoutes = () => (
  <Router history={history}>
    {/* Email OTP (MFA) login */}
    <Route exact path={loginPath} component={Login} />

    <Route exact path={outreachBasePath} component={Outreaches} />
    <Route
      exact
      path={outreachAggregateReportPath}
      component={OutreachAggregateGenerateReport}
    />
    <Route
      exact
      path={outreachAggregateReportHistoryPath}
      component={OutreachAggregateReportHistory}
    />
    <Route
      exact
      path={outreachAggregateReportViewPath}
      component={OutreachAggregateReportView}
    />

    <Route exact path={inventoryDashboardPath} component={InventoryDashboard} />

    {/* Inventory Item Routes */}
    <Route exact path={inventoryItemsPath} component={InventoryItems} />
    <Route
      exact
      path={inventoryCreateItemPath}
      component={CreateInventoryItem}
    />
    <Route exact path={inventoryEditItemPath} component={EditInventoryItem} />
    <Route exact path={inventoryViewItemPath} component={ViewInventoryItem} />
    <Route path={inventoryAdjustItemPath} component={AdjustInventoryItem} />
    <Route
      exact
      path={inventoryItemsAvailabilityPath}
      component={InventoryItemsAvailability}
    />
    <Route
      exact
      path={inventoryItemsAuditLogsPath}
      component={InventoryItemsAuditLogs}
    />

    {/* Inventory Import Items */}
    <Route
      exact
      path={inventoryItemsImportPath}
      component={InventoryImportItems}
    />

    {/* Inventory Import Items Quantity */}
    <Route
      exact
      path={inventoryItemsQauntityImportPath}
      component={InventoryImportItemsQuantity}
    />
    {/* --- End of routes */}

    {/* Inventory Package Routes */}
    <Route exact path={inventoryPackagesPath} component={InventoryPackages} />
    <Route
      exact
      path={inventoryCreatePackagePath}
      component={CreateInventoryPackage}
    />
    <Route
      exact
      path={inventoryEditPackagePath}
      component={EditInventoryPackage}
    />
    <Route
      exact
      path={inventoryViewPackagePath}
      component={ViewInventoryPackage}
    />
    <Route
      path={inventoryAdjustPackagePath}
      component={AdjustInventoryPackage}
    />
    <Route
      exact
      path={inventoryPackagesAvailabilityPath}
      component={InventoryPackagesAvailability}
    />
    {/* --- End of routes */}

    <Route exact path={inventoryTagsPath} component={InventoryTags} />

    {/* Inventory Location Routes */}
    <Route exact path={inventoryLocationsPath} component={InventoryLocations} />
    <Route
      exact
      path={inventoryCreateLocationPath}
      component={InventoryCreateLocation}
    />
    <Route
      exact
      path={inventoryEditLocationPath}
      component={InventoryEditLocation}
    />
    <Route
      exact
      path={inventoryViewLocationPath}
      component={InventoryViewLocation}
    />

    {/* Inventory Guest Summary Report */}
    <Route
      exact
      path={inventoryGuestSummaryReportPath}
      component={InventoryGuestSummaryReport}
    />

    {/* Inventory Donor Summary Report */}
    <Route
      exact
      path={inventoryDonorSummaryReportPath}
      component={InventoryDonorSummaryReport}
    />

    {/* Inventory Low Stock Items */}
    <Route
      exact
      path={inventoryLowStockItemsPath}
      component={InventoryLowStockItems}
    />
    {/* Inventory OnHand */}
    <Route exact path={inventoryOnHandPath} component={InventoryOnHand} />

    {/* Inventory ItemsSkus */}
    <Route
      exact
      path={inventoryItemsAndPackagesSkusPath}
      component={ItemsAndPackagesSkus}
    />

    {/* Storages */}
    <Route exact path={storageDashboardPath} component={StorageDashboard} />
    <Route exact path={storageListPath} component={StorageList} />

    {/* POS */}
    <Route exact path={posViewOrderPath} component={PosOrder} />

    {/* Reservations */}
    <Route
      exact
      path={reservationsBasePath}
      component={ReservationsDashboard}
    />
    <Route exact path={reservationsEditPath} component={ReservationsEdit} />
    <Route exact path={reservationsViewPath} component={ReservationsView} />
    <Route exact path={reservationsOrdersPath} component={ReservationsOrders} />
    <Route exact path={reservationsCreatePath} component={ReservationsCreate} />
    <Route exact path={reservationsTodaysPath} component={ReservationsTodays} />
    <Route
      exact
      path={reservationsUpcomingPath}
      component={ReservationsUpcoming}
    />
    <Route
      exact
      path={reservationsPendingPath}
      component={ReservationsPending}
    />
    <Route
      exact
      path={reservationsUpcomingEventsPath}
      component={ReservationsUpcomingEvents}
    />
    <Route
      exact
      path={reservationsArchivedPath}
      component={ReservationsArchived}
    />
    <Route
      exact
      path={reservationsROItemCreatePath}
      component={ReservationROItemCreate}
    />
    <Route
      exact
      path={reservationsROItemEditPath}
      component={ReservationROItemEdit}
    />
    <Route
      exact
      path={reservationsROItemViewPath}
      component={ReservationROItemView}
    />
    <Route
      exact
      path={reservationsROPicklistCreatePath}
      component={ReservationROPicklistCreate}
    />
    <Route
      exact
      path={reservationsROPicklistEditPath}
      component={ReservationROPicklistEdit}
    />
    <Route
      exact
      path={reservationsROPicklistViewPath}
      component={ReservationROPicklistView}
    />
    <Route
      exact
      path={reservationsROItemListPath}
      component={ReservationROItemList}
    />
    <Route
      exact
      path={reservationsROPicklistListPath}
      component={ReservationROPicklistList}
    />
    <Route
      exact
      path={reservationsOrderedItemsReportsPath}
      component={ReservationOrderedItemsReport}
    />

    {/* Guests */}
    <Route exact path={guestsBasePath} component={GuestList} />
    <Route exact path={guestsViewPath} component={GuestView} />
    <Route exact path={guestsCreatePath} component={GuestCreate} />
    <Route exact path={guestsMergePath} component={GuestMerge} />
    <Route exact path={guestsVisitTrackViewPath} component={VisitTrackView} />

    {/* Settings */}
    <Route
      exact
      path={settingsPortalPath}
      component={SettingsPortalDashboard}
    />
    <Route
      exact
      path={settingsPortalPantryPath}
      component={SettingsPortalPantry}
    />
    <Route
      exact
      path={settingsPortalUsersPath}
      component={SettingsPortalUsers}
    />
    <Route
      exact
      path={settingsPortalSmtpAccountPath}
      component={SettingsPortalSmtpAccount}
    />
    <Route exact path={settingsPosPath} component={SettingsPosDashboard} />
    <Route
      exact
      path={settingsPosTrackingMethodLocationsPath}
      component={SettingsPosTrackingMethodLocations}
    />
    <Route
      exact
      path={settingsPosTrackingMethodLocationsEditPath}
      component={SettingsPosEditTrackingMethodLocations}
    />

    {/* SignaturePad */}
    <Route path={signaturePadPath} component={SignaturePad} />

    {/* Create New Visit */}
    <Route path={createNewVisitPath} component={CreateNewVisit} />

    {/* Guest Reservations */}
    <Route path={guestReservationPath} component={GuestReservations} />

    {/* Visit History Report */}
    <Route exact path={visitHistoryReportPath} component={VisitHistoryReport} />
  </Router>
);

export default AppRoutes;
